<template>
    <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" aria-hidden="true" focusable="false">
        <defs>
            <clipPath :id="clipId">
                <path :d="cutoutPath" />
            </clipPath>
            <linearGradient
                v-for="band in bands"
                :id="`shape-overlay-${band.id}`"
                :key="band.id"
                gradientUnits="userSpaceOnUse"
                :x1="band.x1"
                :y1="band.y1"
                :x2="band.x2"
                :y2="band.y2"
            >
                <stop
                    v-for="([offset, opacity], i) in band.stops"
                    :key="i"
                    :offset="offset"
                    stop-color="#000"
                    :stop-opacity="opacity"
                />
            </linearGradient>
        </defs>
        <!-- fill must be a literal colour: html2canvas serialises this SVG without the page's CSS -->
        <path :fill="color" fill-rule="evenodd" :d="matPath" />
        <rect
            v-for="band in bands"
            :key="band.id"
            :x="band.x"
            :y="band.y"
            :width="band.width"
            :height="band.height"
            :fill="`url(#shape-overlay-${band.id})`"
        />
        <g v-if="showBorder" :clip-path="`url(#${clipId})`">
            <path :d="cutoutPath" fill="none" :stroke="borderColor" :stroke-width="BORDER_WIDTH * 2" />
        </g>
    </svg>
</template>

<script>
import { SHAPE_VIEWBOX, MAT_PATH, SHAPE_CUTOUTS, BEVEL_BANDS } from './shapeOverlay';

const BORDER_WIDTH = 4;

export default {
    name: 'ShapeOverlay',
    props: {
        shape: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: '#fefefe',
        },
        showBorder: {
            type: Boolean,
            default: true,
        },
        borderColor: {
            type: String,
            default: '#001426',
        },
    },
    data() {
        return {
            viewBox: SHAPE_VIEWBOX,
            bands: BEVEL_BANDS,
            clipId: `map-cutout-clip-${this._uid}`,
            BORDER_WIDTH,
        };
    },
    computed: {
        cutoutPath() {
            return SHAPE_CUTOUTS[this.shape] || SHAPE_CUTOUTS.shape_rectangle;
        },
        matPath() {
            return MAT_PATH + this.cutoutPath;
        },
    },
};
</script>
